import { Route, Routes, Navigate } from 'react-router-dom';
// import { LandingPage } from "../../pages/LandingPage";
// import { LoginPage } from "../../pages/RegisterSystem/Login";
import { PersonalRegisterPage } from '../../pages/RegisterSystem/PersonalRegisterPage';
import { CompanyRegisterPage } from '../../pages/RegisterSystem/CompanyRegisterPage';
import { RegisterTypePage } from "../../pages/RegisterSystem/RegisterTypePage";
// import { RePasswordPage } from "../../pages/RegisterSystem/RePasswordPage";
// import { useNavigate } from 'react-router-dom';
export function AppRegister() {
    // const navigate = useNavigate()
    // const user = JSON.parse(localStorage.getItem("userData"))
    
    return (

        <Routes>

            {/* <Route
                index= "true"
                element={user ? <LandingPage /> : <LoginPage/>}
            /> */}
            {/* <Route
                path="landing"
                element={<LandingPage />}
            /> */}
            <Route
                path="registerType"
                element={<RegisterTypePage />}
            />
            <Route
                path="registerType/personal"
                element={<PersonalRegisterPage />}
            />
            <Route
                path="registerType/company"
                element={<CompanyRegisterPage />}
            />
            {/* <Route
                path="repassword"
                element={<RePasswordPage />}
            /> */}
      

            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>

    );

}